
import Vue from 'vue'

export default Vue.extend({
  name: 'BillingMultipliers',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: 'Invalid',
    },
  },
  methods: {
    handleChange(newVal: string) {
      this.$emit('input', parseFloat(newVal))
    },
  },
})
